<template>
  <!--半成品管理-->
  <div>
    <s-pageheader title="订单管理" />
    <!--半成品-->
    <ak-model-filter-card model="order" @search="search" @reset="reset" />

    <ak-model-card model="order" :page.sync="page" :filters="filters" :perPage="30" />

    <!-- <div v-if="adminRole !== 'sale' && cardShow"> -->
    <div v-if=" cardShow">
      <a-modal v-model="visible" footer @ok="handleOk" @cancel="handleCancel" :width="960">
        <view-formila :formulas="formulas" :title="title" />
      </a-modal>
    </div>

    <div v-if="!cardShow">
      <a-modal v-model="visible" footer :title="`${title}配方`" @ok="visible=false" :width="960">
        <div class="formula" v-for="(item,index) in formulasData" :key="index">
          <div class="formulaF">
            <span v-show="item.type==='parts'">半成品：</span>
            <span v-show="item.type==='rawMaterial'">原材料：</span>
            {{item.data.name}} {{ item.weight }}KG {{ item.percentage }}%配比
          </div>
          <div v-if="item.data.formula" class="formulaSon">
            <div
              v-for="(itm,idx) in item.data.formula"
              :key="idx"
            >{{ itm.rawMaterial.name }}&nbsp;&nbsp;&nbsp;&nbsp;{{ itm.weight + "kg" }}</div>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader/PageHeader'
import ViewFormila from '../core/components/viewFormula'
import Bus from '../assets/js/eventBus'
import { mapState } from 'vuex'
// import store from './../store'
import NP from 'number-precision'
export default {
  components: {
    's-pageheader': PageHeader,
    ViewFormila,
  },
  data () {
    return {
      filters: {},
      page: 1,
      visible: false,
      formulas: [],
      title: '订单',
      cardShow: true,
      // adminRole: store.state.user.adminRole,
      formulasData: []
    }
  },
  computed: {
    ...mapState(['user'])
  },
  created () {
    if (window.outerWidth > 1200) {
      // pc端左侧展示
      this.cardShow = true
    } else {
      // 移动端弹窗
      this.cardShow = false
    }
  },
  methods: {
    search (filters) {
      // filters是组件自动生成的where搜索参数
      this.page = 1
      this.filters = filters // 修改modelTable的查询条件会自动触发刷新
    },
    reset () {
      this.page = 1
      this.filters = {}
      Bus.$emit('reset', '')
    },
    // 获取原材料
    async getRawMaterial (data) {
      const { data: res } = await this.$tkParse.get(
        `/classes/rawMaterial/${data.rawMaterial}`
      )

      return res
    },
    // 获取半成品
    async getParts (data) {
      const { data: res } = await this.$tkParse.get(
        `/classes/parts/${data.parts}`
      )

      return res
    },
    async onFormula (payload) {
      this.formulas = payload.finishProductid.formula
      this.title = payload.finishProductid.name
      if (window.outerWidth < 1200) {
        let allWeight = 0
        for (let i in this.formulas) {
          allWeight = NP.plus(allWeight, this.formulas[i].weight)
          if (this.formulas[i].parts) {
            const res = await this.getParts(this.formulas[i])
            this.formulasData.push({
              data: res,
              weight: this.formulas[i].weight,
              type: 'parts'
            })
          } else {
            const res = await this.getRawMaterial(this.formulas[i])
            this.formulasData.push({
              data: res,
              weight: this.formulas[i].weight,
              type: 'rawMaterial'
            })
          }
        }
        for (const item of this.formulasData) {
          this.$set(
            item,
            'percentage',
            NP.times(Number(NP.divide(item.weight, allWeight).toFixed(4)), 100)
          )
        }
      }
    },
    handleOk () {
      this.visible = false
      this.$emit('complete', 'cancel')
    },
    handleCancel () {
      this.$emit('complete')
    },
    showModal () {
      this.visible = true
    }
  },
  mounted () {
    Bus.$on('formula', this.onFormula)
    Bus.$on('showModal', this.showModal)
  },
  beforeDestroy () {
    Bus.$off('formula', this.onFormula)
  }
}
</script>

<style scoped lang="scss">

::v-deep .node-icon:before {
  content: none !important;
}
.formula{
  border-bottom: 1px solid #e5e7ea;
  .formulaF{
  padding:10px 0;
  }
  .formulaSon{
    background-color: rgb(249, 249, 249);
    padding: 10px 20px;
  }
}
</style>
